import {
	Button,
	Card,
	Col,
	DatePicker,
	Form,
	Input,
	Row,
	Select,
	Typography,
} from "antd";

import { Navigate, useNavigate } from "react-router-dom";

import { useState, useEffect } from "react";

import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import moment from "moment";
import { addCustomerPayment } from "../../redux/actions/customerPayment/addCustomerPaymentAction";
import PageTitle from "../page-header/PageHeader";
import { toast } from "react-toastify";
import axios from "axios";

const AddCustPaymentByInvoice = () => {
	const navigate = useNavigate();

	const { pid } = useParams();

	const dispatch = useDispatch();
	const { Title } = Typography;
	const { Option } = Select;

	const [form] = Form.useForm();

	let [date, setDate] = useState(moment());
	const [loader, setLoader] = useState(false);
	const [invoiceDisplay, setInvoiceDisplay] = useState(pid);

	// Fetch sale invoice details to get invoice number with prefix
	useEffect(() => {
		const fetchInvoiceDetails = async () => {
			try {
				const response = await axios.get(`sale-invoice/${pid}`);
				console.log("Sale invoice API response:", response.data);
				// API returns: { singleSaleInvoice: { prefix, invoice_number, ... }, status, ... }
				const invoice = response.data?.singleSaleInvoice;
				console.log("Extracted invoice:", invoice);
				// Combine prefix and invoice_number
				let displayValue = `#${pid}`;
				if (invoice?.prefix && invoice?.invoice_number !== undefined) {
					displayValue = `${invoice.prefix}${invoice.invoice_number}`;
				} else if (invoice?.invoice_number !== undefined) {
					displayValue = `#${invoice.invoice_number}`;
				}
				setInvoiceDisplay(displayValue);
				console.log("Display value:", displayValue);
				// Update form field value - keep the ID for backend submission
				// Use setTimeout to ensure state is updated before setting form value
				setTimeout(() => {
					form.setFieldsValue({ sale_invoice_no: pid });
				}, 0);
			} catch (error) {
				console.log("Error fetching invoice:", error.message);
				setInvoiceDisplay(`#${pid}`);
				form.setFieldsValue({ sale_invoice_no: pid });
			}
		};
		fetchInvoiceDetails();
	}, [pid, form]);

	const onFinish = async (values) => {
		try {
			const data = {
				date: date,
				discount: values.discount || 0,
				...values,
			};

			const resp = await dispatch(addCustomerPayment(data));

			if (resp == "success") {
				navigate(-1);
				setLoader(false);
				toast.success("Payment Added Successfully");
			}

			form.resetFields();
		} catch (error) {
			console.log(error.message);
			setLoader(false);
		}
	};

	const onFinishFailed = (errorInfo) => {
		console.log("Failed:", errorInfo);
		setLoader(false);
	};

	const isLogged = Boolean(localStorage.getItem("isLogged"));

	if (!isLogged) {
		return <Navigate to={"/auth/login"} replace={true} />;
	}

	return (
		<>
			
			<Row className='mr-top'>
				<Col
					xs={24}
					sm={24}
					md={12}
					lg={12}
					xl={14}
					className='border rounded column-design'>
					<Card bordered={false} className='criclebox h-full'>
						<Title level={3} className='m-3 text-center'>
							Sale Invoice Payment
						</Title>
						<Form
							form={form}
							className='m-4'
							name='basic'
							labelCol={{
								span: 8,
							}}
							wrapperCol={{
								span: 16,
							}}
							initialValues={{
								remember: true,
							}}
							onFinish={onFinish}
							onFinishFailed={onFinishFailed}
							autoComplete='off'>
							<Form.Item
								label='Date'
								rules={[
									{
										required: true,
										message: "Please input the date!",
									},
								]}>
								<DatePicker
									onChange={(value) => setDate(value?._d)}
									defaultValue={moment()}
									style={{ marginBottom: "10px" }}
									label='date'
									name='date'
									rules={[
										{
											required: true,
											message: "Please input Date",
										},
									]}
								/>
							</Form.Item>

							<Form.Item
								style={{ marginBottom: "10px" }}
								label='Discount'
								name='discount'
								initialValue={0}>
								<Input type='number' placeholder="Enter discount (optional)" />
							</Form.Item>

							<Form.Item
								style={{ marginBottom: "10px" }}
								label='Amount'
								name='amount'
								rules={[
									{
										required: true,
										message: "Please input amount!",
									},
								]}>
								<Input type='number' />
							</Form.Item>

							<Form.Item
								style={{ marginBottom: "10px" }}
								label='Sale Invoice No'>
								<Input 
									value={invoiceDisplay}
									disabled 
									readOnly
									style={{ color: 'rgba(0, 0, 0, 0.85)' }}
								/>
							</Form.Item>
							{/* Hidden form field to store the actual ID for backend submission */}
							<Form.Item
								name='sale_invoice_no'
								initialValue={pid}
								hidden>
								<Input type="hidden" />
							</Form.Item>

							<Form.Item
								style={{ marginBottom: "10px" }}
								label='Payment Method'
								name='payment_method'>
								<Select placeholder="Select payment method" allowClear>
									<Option value="Cash">Cash</Option>
									<Option value="Bank Transfer">Bank Transfer</Option>
									<Option value="Cheque">Cheque</Option>
									<Option value="Credit Card">Credit Card</Option>
									<Option value="Debit Card">Debit Card</Option>
									<Option value="UPI">UPI</Option>
									<Option value="Other">Other</Option>
								</Select>
							</Form.Item>

							<Form.Item
								style={{ marginBottom: "10px" }}
								label='Reference Number'
								name='reference_number'>
								<Input placeholder="Enter reference/transaction number" />
							</Form.Item>

							<Form.Item
								style={{ marginBottom: "10px" }}
								wrapperCol={{
									offset: 8,
									span: 16,
								}}>
								<Button
									onClick={() => setLoader(true)}
									block
									type='primary'
									htmlType='submit'
									shape='round'
									loading={loader}>
									Pay Now
								</Button>
							</Form.Item>
						</Form>
					</Card>
				</Col>
			</Row>
		</>
	);
};

export default AddCustPaymentByInvoice;
